module.exports = __webpack_public_path__ + "static/media/tdoa_tracker.1c7ff7e5.svg";